/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Asset } from '@wit/vtv-x-foundation-lib';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useRouteMatch } from 'react-router';
import * as NavigationWatcher from 'store/ducks/analytics/navigationWatcher';
import { PrivateRoutePath } from '../routes/paths';

let click = false; // TODO: find a better way to distinguish between click and browser nav

export function useAnalytics() {
  const dispatch = useDispatch();
  const location = useLocation();
  const isProgramInfo = useRouteMatch(PrivateRoutePath.PROGRAM_INFO);

  React.useEffect(() => {
    function handleClick() {
      click = true;
    }
    window.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, []);

  React.useEffect(() => {
    // Program info will deal with the analytics itself, since it has to provide de asset
    if (!isProgramInfo) {
      dispatch(NavigationWatcher.ActionCreators.routeChange(location.pathname, click));
      click = false;
    }
  }, [dispatch, location, isProgramInfo]);
}

export function useProgramInfoAnalytics(asset: Asset | undefined) {
  const dispatch = useDispatch();
  const location = useLocation();
  const [path, setPath] = useState('');

  React.useEffect(() => {
    if (asset && location.pathname !== path) {
      setPath(location.pathname);
      dispatch(NavigationWatcher.ActionCreators.routeChange(location.pathname, click, asset));
      click = false;
    }
  }, [dispatch, asset, location, path]);
}

export function useSearchAnalytics(active: boolean) {
  const dispatch = useDispatch();
  const searchPath = '/search'; // Search is currently a popup window, don't have a specific path, force a fake one for now
  const [prevActive, setPrevActive] = useState(false);

  React.useEffect(() => {
    if (active === true && active !== prevActive) {
      dispatch(NavigationWatcher.ActionCreators.routeChange(searchPath, true));
    }
    setPrevActive(active);
  }, [dispatch, active, prevActive]);
}
